import { Box } from '@mui/material';
import { FC } from 'react';
import { useSnapshot } from 'valtio';
import config from '../config/exclusions-config.json';
import ExclusionsSummaryContainer from './ExclusionsSummaryContainer';
import ExclusionsSideBar from '../components/ExclusionsSideBar';
import ExclusionsStore from '../stores/exclusions-store';
import CollapsiblePanel from '../../elements/CollapsiblePanel/CollapsiblePanel';
import FiltersHeader from '../../elements/FilterBox/FiltersHeader';
import { splitLongNames } from 'string-utils';
import {
  clearFilter,
  clearFilters,
  handleSearchFilterType,
  onChangeFilter,
  toggleFiltersPanel,
} from '../actions/exclusions-filters-actions';
import { exclusionsFilters } from '../utils/exclusion-utils';

const ExclusionsSideBarContainer: FC = () => {
  const {
    filtersOpen,
    numberOfFilters,
    loadingFilters,
    totalExclusions,
    exclusionsFiltersTypes,
    loading,
    filterExclusionsBy,
    searchValues,
    exclusionsFiltersTypeSearch,
  } = useSnapshot(ExclusionsStore);

  return (
    <CollapsiblePanel
      in={filtersOpen}
      collapsedSize={config.sidebar.collapsedSize}
      togglePanel={toggleFiltersPanel}>
      <ExclusionsSideBar
        disabled={loading.isPending() || loading.isPending()}
        exclusionsFilters={exclusionsFilters}
        totalExclusions={totalExclusions}
        filterList={filterExclusionsBy}
        loadingFilters={loadingFilters}
        filters={exclusionsFiltersTypes}
        handleClearFilter={clearFilter}
        onChangeFilter={onChangeFilter}
        searchValues={searchValues}
        exclusionsFiltersTypeSearch={exclusionsFiltersTypeSearch}
        handleSearchFilterType={handleSearchFilterType}>
        <ExclusionsSummaryContainer />
        {totalExclusions > 0 && (
          <Box py={1}>
            <FiltersHeader
              numberOfFilters={numberOfFilters}
              filterIssuesBy={filterExclusionsBy}
              onResetFilters={clearFilters}
              splitFilterTypeName={splitLongNames}
            />
          </Box>
        )}
      </ExclusionsSideBar>
    </CollapsiblePanel>
  );
};

export default ExclusionsSideBarContainer;
